import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";


export class ProgramSubTaskStateSelectComponent implements IController {
  value: any;
  parentValue: any;
  onChange: Function;


  getCurrentValue() {
    const text = _.get(this.value, 'isEnabled') && _.get(this.value, 'isDefault') ? 'Enabled Default' : (_.get(this.value, 'isEnabled') ? 'Enabled' : 'Disabled');
    return (this.value?.isEnabled !== undefined)  ? text : 'Linked to parent';
  }

}


angular
  .module('bringoz.admin.pricePlan')
  .component('programSubTaskStateSelect', {
    bindings: {
      value: '<',
      parentValue: '<?',
      onChange: '&'
    },
    template: require('./program-sub-task-state-select.html').default,
    controller: ProgramSubTaskStateSelectComponent
  });
